import type { AppThunk } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import handleRequestError from 'managers/handleRequestError';
import { setUpdating, setUpdatingKey } from '../slice';
import { DataServiceFlightDefinitionGroups, FlightDefinitionGroupsModel } from 'common/dataService';

function editFlightDefinitionGroups(requestParameters: FlightDefinitionGroupsModel): AppThunk {
  return async function editFlightDefinitionGroupsThunk(dispatch, getState) {
    try {
      const { updating } = getState().flightDefinitionGroups;

      if (updating === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setUpdatingKey('edit'));
      dispatch(setUpdating(FetchingStatus.InProgress));

      await DataServiceFlightDefinitionGroups.putFlightDefinitionGroups(requestParameters);

      dispatch(setUpdating(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(handleRequestError(error, 'Error occured on updating flight definition route!', setUpdating));
    }
  };
}

export default editFlightDefinitionGroups;
